var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash215X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EDB6035E-D287-45B9-B5B5-686BE85337E4@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C10.2426407,0 11.25,1.00735931 11.25,2.25 L11.25,3 L14.25,3 C14.6296958,3 14.943491,3.28215388 14.9931534,3.64822944 L15,3.75 C15,4.16421356 14.6642136,4.5 14.25,4.5 L13.5,4.5 L13.5,14.25 C13.5,15.440864 12.5748384,16.4156449 11.4040488,16.4948092 L11.25,16.5 L3.75,16.5 C2.50735931,16.5 1.5,15.4926407 1.5,14.25 L1.5,4.5 L0.75,4.5 C0.370304234,4.5 0.0565090391,4.21784612 0.006846616,3.85177056 L0,3.75 C0,3.33578644 0.335786438,3 0.75,3 L3.75,3 L3.75,2.25 C3.75,1.05913601 4.67516159,0.084355084 5.84595119,0.00519081254 L6,0 L9,0 Z M12,4.5 L3,4.5 L3,14.25 C3,14.6296958 3.28215388,14.943491 3.64822944,14.9931534 L3.75,15 L11.25,15 C11.6642136,15 12,14.6642136 12,14.25 L12,4.5 Z M6,6.75 C6.41421356,6.75 6.75,7.08578644 6.75,7.5 L6.75,12 C6.75,12.4142136 6.41421356,12.75 6,12.75 C5.58578644,12.75 5.25,12.4142136 5.25,12 L5.25,7.5 C5.25,7.08578644 5.58578644,6.75 6,6.75 Z M9,6.75 C9.41421356,6.75 9.75,7.08578644 9.75,7.5 L9.75,12 C9.75,12.4142136 9.41421356,12.75 9,12.75 C8.58578644,12.75 8.25,12.4142136 8.25,12 L8.25,7.5 C8.25,7.08578644 8.58578644,6.75 9,6.75 Z M9,1.5 L6,1.5 C5.58578644,1.5 5.25,1.83578644 5.25,2.25 L5.25,3 L9.75,3 L9.75,2.25 C9.75,1.87030423 9.46784612,1.55650904 9.10177056,1.50684662 L9,1.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inexplor\\xE9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04_Abonnement",
    transform: "translate(-822.000000, -413.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(104.000000, 386.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-4",
    transform: "translate(387.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/align_justify",
    transform: "translate(311.500000, 4.750000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#162A41",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash215X);
export default __webpack_public_path__ + "static/media/trash_2@1,5x.130cd5b9fa76e412ad239933ce8b9eb7.svg";
export { ForwardRef as ReactComponent };